var $dcc3492993669fc3$exports = {};
$dcc3492993669fc3$exports = {
    "help": `Pomo\u{107}`,
    "info": `Informacije`
};


export {$dcc3492993669fc3$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
